import { styled, css } from 'styled-components';

import { breakpointDesktop, breakpointTablet } from 'src/styles/breakpoints';
import { colorSecondary200 } from 'src/styles/colors';
import { spacing1, spacing2, spacing3, spacing4, spacing5, spacing6 } from 'src/styles/spacing';

export interface StyledInformationCardProps {
  $showBordersForMobile?: boolean;
}

export const StyledInformationCard = styled.div<StyledInformationCardProps>`
  padding: 0 0 ${spacing2};
  ${({ $showBordersForMobile }) =>
    $showBordersForMobile &&
    css`
      border: 1px solid ${colorSecondary200};
      box-shadow: 0 2px 4px rgb(0 0 0 / 15%);
      padding: ${spacing4} ${spacing1};
    `};

  @media (min-width: ${breakpointTablet}) {
    border: 1px solid ${colorSecondary200};
    box-shadow: 0 2px 4px rgb(0 0 0 / 15%);
    padding: ${spacing3} ${spacing2};
  }

  @media (min-width: ${breakpointDesktop}) {
    padding: ${spacing6} ${spacing5};
  }
`;
